module.exports = __webpack_public_path__ + "assets/btn_google.png";